import { FC } from "react";
import { ILink } from "src/@types";
import { Link } from "../Link";
import cn from "classnames";
import { SafeHTML } from "src/components/SafeHTML";
import { scrollTo } from "src/utils/scroll";

export const FooterLinkItem: FC<Omit<ILink, "id">> = ({
  href,
  label,
  icon: Icon,
  isOpenNewTab,
  selector,
}) => {
  const handleClick = selector ? () => scrollTo(selector) : undefined;

  return (
    <li className="text-xs sm:text-sm lg:text-base">
      <Link
        href={href}
        className={cn("flex gap-4 text-white-base hover:text-blue-light")}
        isOpenNewTab={isOpenNewTab}
        isExternalLink={isOpenNewTab}
        isScrollTop={!selector}
        onClick={handleClick}
      >
        {Icon && <Icon className="w-4 h-4 lg:w-6 lg:h-6 xl:w-8 xl:h-8" />}
        <SafeHTML html={label} tag="span" />
      </Link>
    </li>
  );
};
